import React, { useState } from "react";
import { useSelector } from 'react-redux';
import Selector from "canvas-core-react/lib/Selector";
import SecondaryButton from 'canvas-core-react/lib/SecondaryButton';
import { getRelatedCif } from '../../../../../Redux/reducer/cifCross';
import { useTranslation } from "react-i18next";
import Client from "../../../../../../static/images/find-institution.svg";

const AddCompany = ({ back, next }) => {
  const relatedCompanies = useSelector((state) => getRelatedCif(state));
  const [company, setCompany] = useState("");
  const { t } = useTranslation();
  const searchCompany = () => {
    if(company !== "") {
      var companyData = relatedCompanies.find(item => item.child_customer_id === company);
      
      if( companyData !== undefined ) {
        next(company, companyData.child_country);
      } else {
        return false;
      }
    }
  
    return false;
  }

  return <>
    <div className="main-backoffice">
      <img src={Client} className="clientImage" />
      <p className="welcome">{t("providers.related.title")}:</p>
      <p className="client">
      {t("providers.related.subtitle")}
        <br />
        {t("providers.related.second_subtitle")}
      </p>
      <div className="line-client-add"></div>
      <div className="inline-form center-elements">
        <Selector
          id="related-company"
          name="related-company"
          className="no-label related-company"
          label=""
          placeholder="CIF"
          value={company}
          onChange={ e => setCompany(e.target.value) }
        >
          {relatedCompanies.map((cifRelated, idx) => <option key={`opt-related-${idx}`} value={cifRelated.child_customer_id}>{cifRelated.child_customer_id}</option>)}
        </Selector>
      </div>
    </div>
    <div className="form-actions clearfix">
      <SecondaryButton id={`back-btn`} className="btnBack" onClick={back}>Atrás</SecondaryButton>
        {/* <button className={`button button--pill btnBack`} onClick={back}>
          Atrás
        </button> */}
      <SecondaryButton
        id={`continue-btn`}
        className="btnContinue"
        disabled={company === ""}
        onClick={company === "" ? undefined : searchCompany}
      >Continuar</SecondaryButton>
        {/* <button 
          className={`button button--pill btnContinue ${company === "" ? 'disabled' : ''}`}
          onClick={ company === "" ? undefined : searchCompany}>
            Continuar
        </button> */}
      </div>
  </>;
};

export default AddCompany;
